import { AbstractFieldWriteComponent } from '../base-field/abstract-field-write.component';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'ccd-write-date-field',
  template: require('./write-date-field.html')
})
export class WriteDateFieldComponent extends AbstractFieldWriteComponent implements OnInit {

  dateControl: FormControl;

  ngOnInit(): void {
    this.dateControl = this.registerControl(new FormControl(this.caseField.value));

    if (this.datePickerEnabled()) {
      // Force artificial 200ms delay on input touched event to give priority to click on date picker
      this.dateControl['_markAsTouched'] = this.dateControl.markAsTouched;
      this.dateControl.markAsTouched = () => {
        setTimeout(() =>  this.dateControl['_markAsTouched'](), 200);
      }
    }
  }

  isDateTime(): boolean {
    return this.caseField.field_type.id === 'DateTime';
  }

  datePickerEnabled(): boolean {
    if (this.isDateTime()) {
      return false; // Date picker always disabled for date time as it breaks date/time input styling
    }

    if (this.caseField.display_mode_parameters) {
      return this.caseField.display_mode_parameters['datePicker'] === 'true';
    }

    return false;
  }
}
